export const TOPE_REASON_ID = Object.freeze({
	POST_VIAJE: 1,
	CONTROL: 2,
	PREPARACION: 3,
	PRE_CONTIENDA: 4,
})
